export default __webpack_public_path__ + "static/media/Apple_Maps_(WatchOS).447087b1.svg";